import { Pipe, PipeTransform } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

@Pipe({
    name: 'scheduleDisplay',
    standalone: false
})
export class ScheduleDisplayPipe implements PipeTransform {

  public constructor(private translate: TranslateService) {
  }

  transform(value: any[], ...args: unknown[]): Promise<string> {
    return this.translate.get(['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']).toPromise().then(trans => {
      const data = [];
      if(value[0]){
        data.push(trans.sunday);
      }
      if(value[1]){
        data.push(trans.monday);
      }
      if(value[2]){
        data.push(trans.tuesday);
      }
      if(value[3]){
        data.push(trans.wednesday);
      }
      if(value[4]){
        data.push(trans.thursday);
      }
      if(value[5]){
        data.push(trans.friday);
      }
      if(value[6]){
        data.push(trans.saturday);
      }

      return data.join(' ');
    });
  }

}
